import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import './SuperAdminDashboard.css';

export default function SuperAdminDashboard() {
  return (
    <div className="super-admin-dashboard">
      <div className="users-header">
        {/* Adicionado um container para o título e subtítulo para melhor alinhamento */}
        <div
          className="container"
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
        >
          <div>
            <h1 className="page-title">Painel de Controle</h1>
            <p className="page-subtitle">Gestão completa da plataforma.</p>
          </div>
        </div>
      </div>

      <div className="super-admin-layout">
        <aside className="super-admin-sidebar">
          <nav>
            <ul>
              <li>
                <NavLink
                  to="/control-panel/companies"
                  className={({ isActive }) => (isActive ? 'active' : '')}
                >
                  Empresas
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/control-panel/users"
                  className={({ isActive }) => (isActive ? 'active' : '')}
                >
                  Usuários
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/control-panel/exclusions"
                  className={({ isActive }) => (isActive ? 'active' : '')}
                >
                  Lixeira
                </NavLink>
              </li>
            </ul>
          </nav>
        </aside>
        <div className="container">
          <main className="super-admin-content">
            <Outlet /> {/* Aqui serão renderizadas as rotas filhas */}
          </main>
        </div>
      </div>
    </div>
  );
}
